const common = {
  black: '#000',
  white: '#fff'
};

export default common;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui/es/colors/common.js
// module id = iWLa
// module chunks = 11